// Credentials never reach the chat display, saved chats or the action log
const SECRET_KEY = /(token|api_?key|secret|password)$/i
const MAX_DEPTH = 8

export const HIDDEN = "[hidden]"

export function redactSecrets<T>(value: T, depth = 0): T {
  if (depth > MAX_DEPTH || value == null || typeof value !== "object") return value
  if (Array.isArray(value)) return value.map(v => redactSecrets(v, depth + 1)) as T
  const out: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
    out[k] = SECRET_KEY.test(k) && typeof v === "string" && v ? HIDDEN : redactSecrets(v, depth + 1)
  }
  return out as T
}

// Credential formats that get pasted into chat text
const TEXT_SECRETS: RegExp[] = [
  /\bEAA[A-Za-z0-9]{20,}/g, // Meta access tokens
  /\b\d{6,12}:[A-Za-z0-9_-]{30,}/g, // Telegram bot tokens
  /\bsk-[A-Za-z0-9_-]{20,}/g, // OpenAI and Anthropic keys
  /\beyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}/g, // JWTs
]
// "token: abc…": a labelled value with a digit, or too long to be a word ("the token is expired")
const LABELLED = /\b((?:access[ _-]?)?token|api[ _-]?key|secret|password)(\s*[:=]\s*|\s+is\s+)(["'`]?)((?=[^\s"'`]*\d)[^\s"'`]{8,}|[^\s"'`]{16,})\3/gi
// Long runs of letters and digits, like most API keys. Ids are shorter or have dashes
const LONG_KEY = /\b(?=[A-Za-z0-9]*\d)(?=[A-Za-z0-9]*[A-Za-z])[A-Za-z0-9]{32,}\b/g

export function redactText(text: string): string {
  let out = text.replace(LABELLED, (_m, label, sep, quote) => `${label}${sep}${quote}${HIDDEN}${quote}`)
  for (const re of TEXT_SECRETS) out = out.replace(re, HIDDEN)
  return out.replace(LONG_KEY, HIDDEN)
}
